export default class StickyFooterLink {
    constructor() {
         const selector = '.menu__item--get-started';
         this.$originalEl = jQuery(selector);
         this.$link = this.$originalEl.find('a');
         if (this.$link.length < 1) {
             return;
         }

         const $stickyFooter = jQuery('<ul class="sticky-footer-cta">');
         this.$originalEl.clone().appendTo($stickyFooter);
         $stickyFooter.appendTo('body');
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/StickyFooterLink.js